import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import { getInstructionalAreaStrength } from '../utils';
import CommonStrings from 'resources/common-strings';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'IAGoalSelectionContainer',
    propTypes: {
        currentTestEvent: PropTypes.instanceOf(Immutable.Map),
        selectedGoals: PropTypes.instanceOf(Immutable.List),
        selectGoals: PropTypes.func.isRequired,
    },

    selectedIA(event, goal) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.instructionalAreas, 'change-instructional-area');
        if (goal) {
            this.props.selectGoals(Immutable.List.of(goal));
        } else {
            this.props.selectGoals(Immutable.List());
        }
    },

    render() {
        if (!this.props.currentTestEvent) {
            return null;
        }
        const goals = [];
        if (this.props.currentTestEvent.get('goals')) {
            let goalClass = 'view-all-tab-wrapper';
            let goalDivClass = 'view-border';
            if (this.props.selectedGoals.size != 1) {
                goalClass = 'view-all-tab-wrapper active';
                goalDivClass = 'view-border active';
            }
            goals.push(
                <li key="border" className={goalClass} onClick={(event) => this.selectedIA(event, null)}>
                    <div key="border-view" className={goalDivClass}>
                        <p key="view-all-instructional-area" className="tab-text">
                            View All Instructional Areas
                        </p>
                    </div>
                </li>
            );
        }
        if (this.props.currentTestEvent.get('goals')) {
            this.props.currentTestEvent
                .get('goals')
                .sortBy((a) => a.get('score'))
                .map((goal) => {
                    const instructionalAreaStrength = getInstructionalAreaStrength(
                        this.props.currentTestEvent.get('score'),
                        this.props.currentTestEvent.get('standardError'),
                        goal.get('score'),
                        goal.get('standardError')
                    );

                    const goalKeyDivId = 'name-' + goal.get('goalkey');
                    let iaStrengthDiv = '';
                    if (instructionalAreaStrength != '') {
                        iaStrengthDiv = (
                            <span
                                key="strength-text"
                                className="tab-selection-ia-strength icon icon-focus strength-icon"
                            >
                                {instructionalAreaStrength}
                            </span>
                        );
                    }

                    let goalClass = 'tab-wrapper';
                    let borderClass = 'tab-border';
                    if (
                        this.props.selectedGoals.size == 1 &&
                        this.props.selectedGoals.first().get('goalkey') == goal.get('goalkey')
                    ) {
                        goalClass = 'tab-wrapper active';
                        borderClass = 'tab-border active';
                    }

                    goals.push(
                        <li
                            key={goal.get('goalkey')}
                            className={goalClass}
                            onClick={(event) => this.selectedIA(event, goal)}
                        >
                            <p key={goal.get('goalkey') + '-' + goal.get('name')} className="tab-text">
                                {goal.get('name')}
                                {iaStrengthDiv}
                            </p>
                            <div key="border" className={borderClass}>
                                <span key={'score-tab-' + goal.get('goalkey')} className="tab-score">
                                    {goal.get('score')}
                                </span>
                                <span
                                    key={'standardError-' + goal.get('goalkey')}
                                    className="goal-selection-standard-error"
                                >
                                    {CommonStrings.plusOrMinus + CommonStrings.space + goal.get('standardError')}
                                </span>
                            </div>
                        </li>
                    );
                });
        } else {
            return null;
        }

        const testKey = this.props.currentTestEvent.get('testkey');

        return (
            <ul key="nav-tabs" className="nav-tabs">
                {goals}
            </ul>
        );
    },
});
